export enum StatusResponse {
    "SUCCESS" = "SUCCESS",
    "FAILUR" = "FAILUR",
}